import { createSlice } from "@reduxjs/toolkit";

const movieSlice = createSlice({
  name: "movies",
  initialState: {
    popular: [],
    now_playing: [],
    top_rated: [],
    upcoming: [],
    moviesByName: [],
    favouriteMovies: [],
    moodMovies: [],
  },
  reducers: {
    setPopularMovies: (state, action) => {
      state.popular = action.payload;
    },
    setPlayingMovies: (state, action) => {
      state.now_playing = action.payload;
    },
    setTopMovies: (state, action) => {
      state.top_rated = action.payload;
    },
    setUpcomingMovies: (state, action) => {
      state.upcoming = action.payload;
    },
    setMoviesByName: (state, action) => {
      state.moviesByName = action.payload;
    },
    setFavouriteMovies: (state, action) => {
      state.favouriteMovies = [...state.favouriteMovies, action.payload];
    },
    setMoodMovies: (state, action) => {
      state.moodMovies = [...state.moodMovies, action.payload];
    },
  },
});

export const {
  setPlayingMovies,
  setPopularMovies,
  setTopMovies,
  setUpcomingMovies,
  setMoviesByName,
  setFavouriteMovies,
  setMoodMovies,
} = movieSlice.actions;
export default movieSlice.reducer;
